
const state = {  
    extDevicesLijst: [],
    extDeviceTypesLijst: [],
    linkItemsLijst: []
};

export default state;
